import http from '@/common/api/http';

let baseUrl = "/newJava";

// 唯品会千万补贴-返回活动页链接、分享链接
export const subsidyInfo = (data) => {
    return http.post(`${baseUrl}/gylmJ/openapi/v1/subsidyInfo`, data);
};

export const wphSubsidyInfo = (data) => {
    return http.post(`${baseUrl}/gylmJ/wph/subsidy/info`, data);
};

// 唯品会千万补贴-我的奖励订单列表
export const wphSubsidyOrderList = (data) => {
    return http.post(`${baseUrl}/gylmJ/wph/subsidy/order/list`, data);
};
